/**
 * Cross-instance Cognito SSO form-POST helper.
 *
 * Builds and submits a hidden HTML form that POSTs a Cognito ID token to a
 * sibling instance's `/auth/cognito/exchange` endpoint. Using a real form
 * (instead of a fetch) lets the browser follow the server-side redirect and
 * honor the Set-Cookie response that establishes the session on the target.
 */

/**
 * Normalize a raw host/URL to a clean origin. Accepts either `example.com`
 * or `https://example.com/` and returns `https://example.com`.
 * Returns null if the input is blank.
 */
export const buildInstanceOrigin = rawHost => {
  const host = (rawHost || '').replace(/\/$/, '');
  if (!host) return null;
  return /^https?:\/\//i.test(host) ? host : `https://${host}`;
};

/**
 * Submit a Cognito ID-token exchange POST to the given target origin.
 *
 * @param {string} targetOrigin Fully-qualified origin of the sibling instance
 *                              (e.g. `https://other.example.com`).
 * @param {object} params
 * @param {string} params.idToken Cognito ID token to hand off.
 * @param {string|number} [params.targetAccountId] Optional account id to land in.
 */
export const submitCognitoExchangeForm = (
  targetOrigin,
  { idToken, targetAccountId } = {}
) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${targetOrigin}/auth/cognito/exchange`;
  form.style.display = 'none';

  const appendField = (name, value) => {
    if (value == null) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value);
    form.appendChild(input);
  };

  appendField('id_token', idToken);
  appendField('target_account_id', targetAccountId);

  document.body.appendChild(form);
  form.submit();
};
